export const IconExternalLink = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M19 9a1 1 0 1 0 2 0V5a2 2 0 0 0-2-2h-4a1 1 0 1 0 0 2h2.586l-6.293 6.293a1 1 0 0 0 1.414 1.414L19 6.414z" />
      <path
        fillRule="evenodd"
        d="M3 6a3 3 0 0 1 3-3h5a1 1 0 1 1 0 2H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 1 1 2 0v5a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
        clipRule="evenodd"
      />
    </svg>
  );
};
